import React, { useState, useEffect } from "react";
import Breadcrumb from "../../../parts/Breadcrumb";
import { useHistory } from "react-router-dom";
import { pluck, reject, contains } from "underscore";
import ListSection from "../../../components/ListSection";
import labels from "../../../constants/Reports";
import configuration from "../../../config";
import { toast } from "react-toastify";
import { getAccessRights } from "../../../utils/common";
import Loader from "../../../components/Loader/Loader";

// List all users
function View({ location }) {
  const [isLoader, setIsLoader] = useState(false);

  const columns = [
    {
      title: "ID",
      field: "user_id",
    },
    {
      title: "Name",
      field: "first_name",
      render: (rowData) => (
        <span>
          {rowData.first_name} {rowData.last_name}
        </span>
      ),
    },
    { title: "Email", field: "email" },
    {
      title: "Mobile",
      field: "mobile",
      render: (rowData) => (
        <span>
          {rowData.mobile_country_code} {rowData.mobile}
        </span>
      ),
    },
    { title: "Total Trips", field: "totalRecord" },
    { title: "Sign up date", field: "created_at" },
  ];
  const [data, setData] = useState([]);

  const btnGroups = [
    {
      id: 2,
      title: "Export CSV",
      type: "exportCSV",
      path: "/user",
      fileName: "Trips",
    },
  ];
  const fieldArr = [
    {
      id: 3,
      title: "From  Date",
      name: "from_date",
      type: "DatePicker",
      disablePast: false,
      disableFuture: true,
    },
    {
      id: 4,
      title: "To Date",
      name: "to_date",
      type: "DatePicker",
      disablePast: false,
      disableFuture: true,
    },
  ];
  const [fieldsFilter, setFieldsFilter] = useState({
    from_date: null,
    to_date: null,
  });
  const [errorsFilter, setErrorsFilter] = useState({
    from_date: "",
    to_date: "",
  });

  const [ids, setIds] = useState([]);
  const history = useHistory();

  useEffect(() => {
    getAccessRights().then((rights) => {
      const rightsData = rights?.find(
        (ac) => ac.code === "TOP_TRIP_BOOKING_DISPATCHERS"
      );
      if (rightsData?.view === false) {
        history.push("/dashboard");
      }
    });
    getDatas({});
  }, []);

  function getDatas(filterData) {
    setIsLoader(true);
    configuration
      .getAPI({
        url: "report/top-performings",
        params: { filterData: JSON.stringify(filterData), type: "dispatcher" },
      })
      .then((data) => {
        setIsLoader(false);
        if (data.status === 200) {
          setData(data.payload);
        }
      })
      .catch((error) => {
        setIsLoader(false);
        return toast.error(error.message);
      });
  }
  const onSelectionChange = (e) => {
    let idArr = pluck(e, "user_id");
    setIds(idArr);
  };

  function handleApplyFilter() {
    if (handleFilterValidation()) {
      getDatas(fieldsFilter);
    }
  }
  function handleClearFilter() {
    setFieldsFilter({ status: [], from_date: null, to_date: null });
    getDatas({});
    setErrorsFilter({});
  }
  function handleChangeFilter(field, e) {
    if (field === "status") {
      console.log(field);
      console.log(e.target.value);
      let sessionData = fieldsFilter.status ? fieldsFilter.status : [];
      if (!contains(sessionData, e.target.value)) {
        sessionData.push(e.target.value);
      } else {
        sessionData = reject(sessionData, function (num) {
          return num === e.target.value;
        });
      }
      console.log(sessionData);
      setFieldsFilter({ ...fieldsFilter, [field]: sessionData });
      if (sessionData && sessionData.length <= 0) {
        delete fieldsFilter.status;
        getDatas({ fieldsFilter });
      } else {
        getDatas({ ...fieldsFilter, [field]: sessionData });
      }
    } else {
      setFieldsFilter({ ...fieldsFilter, [field]: e });
    }
  }
  function handleFilterValidation() {
    let flag = true;
    let error = {};

    const { from_date, to_date } = fieldsFilter;

    if (!from_date && to_date) {
      error.from_date = "Please select from date";
      flag = false;
    }

    if (from_date && !to_date) {
      error.to_date = "Please select to date";
      flag = false;
    }

    if (!from_date && !to_date) {
      error.from_date = "Please select from date";
      error.to_date = "Please select to date";
      flag = false;
    }

    if (from_date && to_date && to_date < from_date) {
      error.to_date = "To date must be greater than or equal to From date";
      flag = false;
    }

    setErrorsFilter(error);
    return flag;
  }

  return (
    <>
      {isLoader ? <Loader /> : ""}
      <Breadcrumb module={labels.TopBookingDispatcher} />
      <ListSection
        captionTitle="Top Trip Booking Dispatcher"
        columns={columns}
        data={data}
        btnGroups={btnGroups}
        csvTitle={"Top_Trip_Booking_Dispatcher_"}
        filters={true}
        status={false}
        fieldArr={fieldArr}
        disabledCheckbox={true}
        onSelectionChange={onSelectionChange}
        handleApplyFilter={handleApplyFilter}
        handleClearFilter={handleClearFilter}
        handleChangeFilter={handleChangeFilter}
        fieldsFilter={fieldsFilter}
        errorsFilter={errorsFilter}
      />
    </>
  );
}

export default View;
